import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAxiosUserContext } from './core/config/apiConfig';
import ALLRoutes from './feature-module/router/router';
import { setEmployeeServiceUserContext } from './core/config/employeeApiConfig';
import { fetchActiveCompanyForUser } from './core/data/redux/company/companyDetailsActions';
import { AppDispatch } from './core/data/redux/store';
import { setAssetServiceUserContext } from './core/config/assetApiConfig';
import { setPayrollServiceUserContext } from './core/config/payrollApiConfig';
import { Spin } from 'antd';

const App = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { activeCompany } = useSelector((state: any) => state.companyDetails);
  const [isContextSet, setIsContextSet] = useState(false);

  // Step 1: Fetch active company after login
  useEffect(() => {
    if (user?.UserId) {
      dispatch(fetchActiveCompanyForUser(user.UserId));
    }
  }, [user?.UserId, dispatch]);

  // Step 2: Set Axios & Employee service user context when activeCompany is available
  useEffect(() => {
    if (activeCompany?.company_code && activeCompany?.financial_year && !isContextSet) {
      setAxiosUserContext(activeCompany);
      setEmployeeServiceUserContext(activeCompany);
      setAssetServiceUserContext(activeCompany);
      setPayrollServiceUserContext(activeCompany);
      setIsContextSet(true);
    }
  }, [activeCompany, isContextSet]);

  if (user && !isContextSet) {
    return (
      <div style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Spin size="large" tip="Setting up user context..." />
      </div>
    );
  }

  return <ALLRoutes />;
};

export default App;
